interface UsePrescribeIntervention {
    goToPrescribeFlow: (
        orderDTO: CartOrderModel,
        options: { onError: () => void }
    ) => Promise<void>;
}

export function usePrescribeIntervention(): UsePrescribeIntervention {
    const router = useRouter();
    const localePath = useLocalePath();
    const translatedRoutes = useTranslatedRoutes();

    const goToPrescribeFlow = async (
        orderDTO: CartOrderModel,
        { onError }: { onError: () => void }
    ): Promise<void> => {
        try {
            const data = await $fetch('/api/orders/check', {
                method: 'POST',
                body: orderDTO,
                query: {
                    isBasket: true,
                },
            });
            await router.push(
                `${localePath(translatedRoutes.value.prescribe)}?id=${data?.order.id}`
            );
        } catch (error: unknown) {
            if (error instanceof Error) {
                useLogger().error(error.message);
            }

            onError();
        }
    };

    return {
        goToPrescribeFlow,
    };
}
